/**
 * Returns Promise that never resolves ("hanging").
 */
export async function pHang() {
  return await new Promise(() => void 0);
}